<script setup lang="ts">
import {resolveMediaUrl} from '~/utils/relations'

const jobsFetch = useJobs()

const {pending, data: jobs} = await useAsyncData('jobs', () => jobsFetch.fetch())
</script>

<template>
  <div v-if="jobs && !pending">
    <CareersSection
      id="jobs"
      :title="$t('careers.jobs.title')"
      :eyebrow="$t('careers.jobs.eyebrow')"
      :intro="$t('careers.jobs.description')"
      class="scroll-mt-24"
    >
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-8">
        <CareersJob
          v-for="item of jobs"
          :key="item.id"
          :title="item.title"
          :position-type="item.positionType"
          :level="item.careerLevel"
          :icon="resolveMediaUrl(item.icon) ?? ''"
          :location="item.location"
          :job="item"
          :slug="item.slug"
        />
      </div>
    </CareersSection>
  </div>
</template>
